<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Editor from "../components/Editor.svelte";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import OfferVehiclePrice from "./OfferVehiclePrice.svelte";
    import OfferRoutes from "./OfferRoutes.svelte";

    export let offerId = null;
    export let closeCallback;

    let offer = null;
    let isModified = false;
    let departments = [];
    let locations = [];
    let tours = [];


    const emptyOffer = () => {
        return {
            id: 0,
            name: '',
            title: '',
            description: '',
            content: '',
            max_pax: 0,
            vehicle_prices: [],
            is_best: 0,
            is_active: 1,
            routes: [],
            department_ids: [],
        }
    }

    const load = () => {

        const onSuccess = result => {
            locations = result.locations;
            departments = result.departments;
            tours = result.tours;

            if (offerId == 0) {
                offer = emptyOffer();
            } else {
                offer = result.offer;
            }

            departments.map(item => {
                item.is_selected = offer.department_ids.indexOf(item.id) > -1 ? 1 : 0;
            });

            setFocusTo('offerName');
        };

        const onFailure = err => {
        };

        R.handle(R.offer.details, offerId == 0 ? 'new' : offerId, onSuccess, onFailure, LOADER.POPUP);
    };

    const save = () => {
        const onSuccess = result => {
            offer.id = result.id;
            offerId = result.id;
            isModified = true;
            Notifier.showMessage("Offer updated");
        }

        const onFailure = err => {
            console.log(err);
        };

        offer.name = offer.name.trim();
        if (!offer.name) {
            Notifier.showError("Type the name of the offer");
            setFocusTo("offerName");
            return;
        }

        offer.title = offer.title.trim();
        if (!offer.title) {
            Notifier.showError("Type the title of the offer");
            setFocusTo("offerTitle");
            return;
        }

        if (offer.routes.length == 0) {
            Notifier.showError("You must enter at least one route for this offer!");
            return;
        }

        offer.department_ids = departments.map(item => {
            if (item.is_selected == 1) {
                return item.id;
            }
        }).filter(x => x !== undefined);

        if (offer.department_ids.length == 0) {
            Notifier.showError("You must select at least one department for this offer!");
            return;
        }

        let action = offerId == 0 ? 'create' : 'edit';
        R.handle(R.offer[action], offer, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = () => {
        if (isModified) {
            closeCallback(offer);
            return;
        }

        closeCallback();
    }

    const onContentChange = ({detail}) => {
        offer.content = detail.text;
    }

    load();
</script>

{#if offer}
    <Modal modalXl title="Offer details" on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group">
                        <div class="h6 fw-semibold mb-3">Apply to Departments</div>
                        <div class="d-flex flex-column gap-2">
                            {#each departments as department}
                                <Checkbox label={department.name} bind:checked={department.is_selected}/>
                            {/each}
                        </div>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Name</label>
                        <input type="text" class="form-control" id="offerName" bind:value="{ offer.name }">
                    </div>
                    <div class="form-group">
                        <label>Title</label>
                        <input type="text" class="form-control" id="offerTitle" bind:value="{ offer.title }">
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" bind:value="{ offer.description }"></textarea>
                    </div>
                    <div class="form-group">
                        <Editor text="{ offer.content }" on:change={ onContentChange }/>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group">
                            <Checkbox label="Active offer" bind:checked={ offer.is_active }/>
                        </div>
                        <div class="col-md-4 form-group">
                            <Checkbox label="Best offer" bind:checked={ offer.is_best }/>
                        </div>
                    </div>
                </div>

                <div class="col-md-2">
                    <OfferRoutes bind:offer {locations} {tours}/>
                </div>
                <div class="col-md-2">
                    <div class="legend mb-2">Vehicle Prices</div>
                    <OfferVehiclePrice bind:value={offer.vehicle_prices}/>
                </div>
            </div>

            <hr>
            <div class="text-end">
                <button class="btn btn-link me-2" on:click="{ () => close() }">Close</button>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}